// api/student-progresso.ts
//
// W5 Session 1 — student-self Indice + per-argomento mastery rings.
// Separate from `api/progress.ts` (which targets the legacy
// `/api/progress/summary` Home stats endpoint) so the two grow
// independently. Shape mirrors the BE `StudentSelfProgressoPayload`.

import { apiJson } from './client';

export interface StudentSelfProgressoArgomento {
  argomento_id:        string;
  name_it:             string;
  sort_order:          number;
  /** 0..1 coverage-aware readiness for this argomento; unseen active principles count as 0. */
  average_mastery:     number;
  /** Total active principles in this argomento. */
  principles_total:    number;
  /** Active principles with answered evidence (`encounters > 0`); rows at `encounters = 0` are excluded. */
  principles_observed: number;
  /** Active principles whose fresh confidence/decay display atom clears 0.6; never raw `mastery_score`. */
  principles_mastered: number;
  /** Rounded 0..100 evidence-aware readiness. */
  readinessPct:        number;
  evidenceLabel:       'Non ancora osservato' | 'Pochi dati' | 'Da rinforzare' | 'In consolidamento' | 'Buona base';
  weaknessReason:      'observed_errors' | 'low_coverage' | 'mixed' | 'none';
}

export interface StudentSelfProgresso {
  perArgomentoMastery: StudentSelfProgressoArgomento[];
  currentIndice: {
    /** 0..100 integer composite (matches the staff-dashboard handler). */
    indice:           number;
    correctCount:     number;
    totalPrinciples:  number;
  };
}

export const studentProgressoApi = {
  async fetch(): Promise<StudentSelfProgresso> {
    return apiJson<StudentSelfProgresso>('/api/student/progresso', { method: 'GET' });
  },
};
